import { datadogRum } from '@datadog/browser-rum';
import { getDefaultStore } from 'jotai';
import { MiddlewareFunction } from 'react-router-dom';

import { cookieJar, fetchAccount } from '@consumer-frontend/nc-api';
import { accountTransform, registrationTransform } from '@consumer-frontend/nc-utils';

import {
  accountAtom,
  doesPasswordExistAtom,
  doesServerHaveIncomeDataAtom,
  incomeDataAtom,
  isReturningCustomerFlowAtom,
  registrationDataAtom,
} from '../../store';
import { hasIncome } from '../checks';

const store = getDefaultStore();

export const loadReturningCustomerData: MiddlewareFunction = async () => {
  if (store.get(accountAtom)) { return; }

  if (!cookieJar.getAccessToken()) { return; }

  try {
    const accountResponse = await fetchAccount();
    const account = accountTransform.deserialize(accountResponse);
    const registrationData = registrationTransform.deserialize(accountResponse);

    const income = {
      amount: account.income?.amount,
      benefits: account.income?.benefits,
      employment: account.income?.employment,
      source: account.income?.source,
    };

    store.set(incomeDataAtom, income);
    store.set(doesPasswordExistAtom, account.passwordExists);

    const isReturningCustomerFlow = store.get(isReturningCustomerFlowAtom);

    if (isReturningCustomerFlow === undefined) {
      store.set(isReturningCustomerFlowAtom, account.passwordExists);
    }

    // TODO: move to derived atom
    if (hasIncome(accountResponse)) { store.set(doesServerHaveIncomeDataAtom, true); }

    store.set(registrationDataAtom, (prev) => ({ ...prev, ...registrationData }));
    store.set(accountAtom, (prev) => ({ ...prev, ...account }));
  } catch (error) {
    datadogRum.addError(error, { context: 'loadReturningCustomerData' });
    // Throw to trigger the route error boundary (generic error page) — e.g. a 500 on lookup.
    throw error;
  }
};
